//Componentes generales
import { useContext, useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
//Imagenes
import qr from '../../images/qr.png';

import QRCode from 'react-qr-code';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

import productoG4 from '../../images/productoDeG4.png'
import MANTENIMIENTO from '../../images/MANTENIMIENTO.png';
import LOGOBLANCO from '../../images/LOGO-BLANCO.png'

// Alertas
import Swal from 'sweetalert2'

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faImage} from "@fortawesome/free-solid-svg-icons";

// Constants
import './FormActivo.css';
import { PRINCIPAL, SECUNDARY_COLOR, NAVBARS, COLOR_BOTONES } from '../../constants/colors';

//Components
import FormActivoType from '../FormActivoType/FormActivoType';
import FormNivel1 from '../FormNivel1/FormNivel1';
import FormNivel2 from '../FormNivel2/FormNivel2';
import SelectControl from '../SelecControl/SelectControl';
import BtnArchivos from '../BtnArchivos/BtnArchivos';

import Select from 'react-select';

//No se utiliza mas
import ComponentesSubtabla from '../componentesSubtabla/ComponentesSubtabla.js';

import ProductosSubtabla from '../productosSubtabla/ProductosSubtabla.js';
import ProcedimientosXactivoSubtabla from '../procedimientosXactivoSubtabla/ProcedimientosXactivoSubtabla.js';
import FueraServicioSubtabla from '../fueraServicioSubtabla/FueraServicioSubtabla.js';
import LecturasSubtabla from '../lecturasSubtabla/LecturasSubtabla.js';
import DocumentosSubtabla from '../documentosSubtabla/DocumentosSubtabla.js';
import PrioritySelect from '../prioritySelect/PrioritySelect.js';

//Contextos
import activoContext from '../../context/activoContex/activoContex';
import activoTypeContext from '../../context/activoTypeContex/activoTypeContex.js';
import nivel1Context from '../../context/nivel1Context/nivel1Context.js';
import nivel2Context from '../../context/nivel2Context/nivel2Context.js';
import nivel3Context from '../../context/nivel3Context/nivel3Context.js';
import FormNivel3 from '../FormNivel3/FormNivel3';
import productosXactivoContext from '../../context/productosXactivoContex/productosXactivoContext.js';  
import authContext from "../../context/authentication/authContex";


import './FormActivo.css';

//Estas estruc
import { estructura_producto, estructuraNivel1, estructuraProcedimiento, estructuraLogsFServ, estructuraActivo, estructuraLectura, estructuraProcedimientoProgramado, estructuraDocumento, unidadesMedidasOpciones, estructuraLogsUbicacion, createEstructuraActivo, createEstructuraProcedimiento, createEstructuraLectura, createEstructuraLogsFServ, createEstructuraFichaTecnica, opcionesPedirLecturaActivo } from '../../utils/estructuras.js';
import ProcedimientosProgramadosSubtabla from '../procedimientosProgramadosSubtabla/ProcedimientosProgramadosSubtabla.js';
import procedimientoContext from '../../context/procedimientoContext/procedimientoContext.js';
import UbicacionesSubtabla from '../ubicacionesSubtabla/UbicacionesSubtabla.jsx';
import { getNewFormattedDate } from '../../utils/funciones';
import UsuariosState from '../../context/usuarios/usuariosState.js';
import usuariosContext from '../../context/usuarios/usuariosContext.js';
import ModalForm from '../modalForm/ModalForm.js';
import FichaTecnicaSubtabla from '../fichaTecnicaSubtabla/FichaTecnicaSubtabla.js';
import DictionaryText from '../dictionaryText/DictionaryText.js';
import nivel4Context from '../../context/nivel4Context/nivel4Context.js';
import nivel5Context from '../../context/nivel5Context/nivel5Context.js';
import FormNivel5 from '../FormNivel5/FormNivel5.jsx';
import FormNivel4 from '../FormNivel4/FormNivel4.jsx';
import BloqueosSubtabla from '../bloqueosSubtabla/BloqueosSubtabla.js';


function FormActivo({handleOnClickEditar, activoToHandle = {}, setActivoToHandle, setOnClickInfo, modo, setModo, validacion, dataTypeList,setDataTypeList, files}) {

    const { usuario, getValorActualFromDictionary } = useContext(authContext);
    const atContext = useContext(activoTypeContext);
    const {activoTypeList} = atContext;
    const nv1Context = useContext(nivel1Context);
    const {nivel1Lista} = nv1Context;
    const pContext = useContext(nivel2Context);
    const {nivel2List} = pContext;
    const prContext = useContext(nivel3Context);
    const {nivel3List} = prContext;
    const {nivel4List} = useContext(nivel4Context);
    const {nivel5List} = useContext(nivel5Context);
    const usrContext = useContext(usuariosContext);
    const {userList, userListView} = usrContext;
    const {actualizarActivoXproducto} = useContext(productosXactivoContext);
    const {actualizaractivoList,agregarActivo, modificarActivo,  eliminarActivo} = useContext(activoContext)

    const refQr = useRef(null);
    
    /*------------Agregado desde que se comenzo el remake de FormActivo------------*/
    const [activo, setActivo] = useState({...createEstructuraActivo()});

    //Estado con todas las opciones de los SelectControl modeladas.
    const [options,setOptions] = useState({opcionesTipoActivos:[], opcionesNivel1s:[], opcionesNivel2s:[], opcionesNivel3s:[], opcionesNivel4s:[], opcionesNivel5s:[], opcionesUsers: []});
    //Especifica que subtabla renderizar.
    const [tablaSeleccionada,setTablaSeleccionada] = useState('fichaTecnica'); 
    //Encargado de especificar que addForm renderizar.
    const [addFormToShow, setAddFormToShow] = useState('');
    
    //Indica el titulo del AddForm renderizado por cada uno de los SelectControl.
    const [nuevoEditado, setNuevoEditado] = useState("Agregar")
    
    //State de los archivos seleccionados.
    const [selectedFiles, setSelectedFiles] = useState([]);

    //State de archivos de documentos (subtabla Documentos)
    const [docFiles, setDocFiles] = useState([]);

    //State de archivos de disponibilidad (subtabla Fuera de Servicio)
    const [fServFiles, setFServFiles] = useState([]);

    const [image, setImage] = useState('');

    const [datoGuardar, setDatoGuardar] = useState()
    const [saving, setSaving] = useState(false);

    const [reset,setReset] = useState(1);

    const [formToShow, setFormToShow] = useState('');
    /*--------------------------*/

    const createOptions = (optionsToCreate = '') => {
        let opcionesTipoActivos = [];
        let opcionesNivel1s = [];
        let opcionesNivel2s = [];
        let opcionesNivel3s = [];
        let opcionesNivel4s = [];
        let opcionesNivel5s = [];
        let optionsDocumentos = [];
        let opcionesUsers = [];

        //Como se formatean las opciones sera trabajado en FormActivo, al ir seleccionando los campos, sus hijos o selecciones siguientes seran filtradas en base a este.
        if(activoTypeList){
            //Modelado Opciones TiposActivo
            opcionesTipoActivos = activoTypeList?.map((dato) =>({name: dato.nameTypeActivo, value: dato.nameTypeActivo, label: dato.nameTypeActivo,codTypeActivo:dato.codTypeActivo, 
            nameTypeActivo:dato.nameTypeActivo, id: dato._id, descrp: dato.descrp }));
        }
        if(nivel1Lista){
            //Modelado Opciones Nivel1s
            opcionesNivel1s = nivel1Lista.map((dato) =>({ name: dato.name, value: dato.name, label: dato.name, id: dato._id, codNivel1: dato.codNivel1, descrp: dato.descrp}));
        } 
        if(nivel2List){
            //Modelado Opciones Nivel2s
            if (activo.nivel1 != undefined) opcionesNivel2s =  nivel2List?.filter(nivel2 => nivel2.nivel2Nivel1ID === activo?.nivel1.id).map(nivel2 => ({name: nivel2.name, value: nivel2.name, label: nivel2.name, id: nivel2._id, codNivel2: nivel2.codNivel2, descrp: nivel2.descrp }));
        }
        if(nivel3List){
            //Modelado Opciones Nivel3s
            if (activo.nivel2 != undefined) opcionesNivel3s = nivel3List?.filter(nivel3 => nivel3.nivel3Nivel2ID === activo?.nivel2.id).map(nivel3 => ({nameNivel3: nivel3.nameNivel3, value: nivel3.nameNivel3, label: nivel3.nameNivel3, id: nivel3._id, codNivel3: nivel3.codNivel3, descrp: nivel3.descrp, nivel3Nivel2ID: nivel3.nivel3Nivel2ID, codNivel2: nivel3.codNivel2 }));
        }
        if(nivel4List){
            //Modelado Opciones Nivel2s
            if (activo.nivel3 != undefined) opcionesNivel4s =  nivel4List?.filter(nivel4 => nivel4.nivel4Nivel3ID === activo?.nivel3.id).map(nivel4 => ({name: nivel4.name, value: nivel4.name, label: nivel4.name, id: nivel4._id, codNivel4: nivel4.codNivel4, descrp: nivel4.descrp }));
        }
        if(nivel5List){
            //Modelado Opciones Nivel2s
            if (activo.nivel4 != undefined) opcionesNivel5s =  nivel5List?.filter(nivel5 => nivel5.nivel5Nivel4ID === activo?.nivel4.id).map(nivel5 => ({name: nivel5.name, value: nivel5.name, label: nivel5.name, id: nivel5._id, codNivel5: nivel5.codNivel5, descrp: nivel5.descrp }));
        }
        if(userList){
            opcionesUsers = userList.map(u => ({comUserID: u._id, value: u.userName, label: u.userName, userName: u.userName}));
        }
        setOptions({opcionesTipoActivos, opcionesNivel1s, opcionesNivel2s, opcionesNivel3s, unidadesMedidasOpciones: unidadesMedidasOpciones, opcionesUsers});
    }

    const handleFileChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            const imagen = URL.createObjectURL(event.target.files[0]);
            setImage(imagen);
            setActivo({...activo, img : imagen === null ? false : true});
            setSelectedFiles([...selectedFiles, {dato: event.target.files[0], campo: 'imagen'}])
        }
    };

    const handleDocFileChange = (index, codDocumento, file) => {
        setDocFiles(prev => {
            const existing = prev.find(f => f.codDocumento === codDocumento && f.accion !== 'DELETE');
            if(file){
                const filtered = prev.filter(f => f.codDocumento !== codDocumento || f.accion === 'DELETE');
                if(existing && !existing.accion){
                    return [...filtered, { codDocumento, name: existing.name, accion: 'DELETE' }, { codDocumento, file, name: file.name, accion: 'ADD' }];
                }
                return [...filtered, { codDocumento, file, name: file.name, accion: 'ADD' }];
            } else {
                if(existing && existing.accion === 'ADD') return prev.filter(f => f.codDocumento !== codDocumento);
                return [...prev.filter(f => f.codDocumento !== codDocumento), { codDocumento, name: existing?.name, accion: 'DELETE' }];
            }
        });
    };

    const handleFServFileChange = (index, rowKey, file) => {
        setFServFiles(prev => {
            const existing = prev.find(f => f.rowKey === rowKey && f.accion !== 'DELETE');
            if(file){
                const filtered = prev.filter(f => f.rowKey !== rowKey || f.accion === 'DELETE');
                if(existing && !existing.accion){
                    return [...filtered, { rowKey, name: existing.name, accion: 'DELETE' }, { rowKey, file, name: file.name, accion: 'ADD' }];
                }
                return [...filtered, { rowKey, file, name: file.name, accion: 'ADD' }];
            } else {
                if(existing && existing.accion === 'ADD') return prev.filter(f => f.rowKey !== rowKey);
                return [...prev.filter(f => f.rowKey !== rowKey), { rowKey, name: existing?.name, accion: 'DELETE' }];
            }
        });
    };

    const handleChange = (e={},prop='',value='') => {
        if(e.target != undefined){ //Si != undefined es que proviene de un input
            let { name, value } = e.target;
            if(name == 'fServ' || name == 'fijo' || name == 'habilitadoProduccion') value = e.target.checked; //Si ename == fServ proviene de checkbox.
            setActivo({
                ...activo,
                [name]: value
            });    
        }else if(prop != '' && value != ''){ //Si se cumple proviene de un SelectControl
            let activoToModify = {...activo};
            //Si cambia la unidad primaria y coincide con la secundaria, auto-limpia la secundaria.
            if(prop == 'DEFAULTUNIMED' && activoToModify.DEFAULTUNIMED2?.value && value.value === activoToModify.DEFAULTUNIMED2.value){
                activoToModify.DEFAULTUNIMED2 = {label:'', value:''};
            }
            setActivo({
                ...activoToModify,
                [prop]: value
            });
        }
    }

    const handleChangeProductos = (prod={}, i, property = '', value = '') => {
        //Se le asigna un id random al item vacio. Esto es para facilitar la eliminación del item en caso de ser necesario.
        setActivo((prevActivo) => {
            const actualList = prevActivo.productos.slice();
            if(property != '' && Object.keys(prod).length == 0){  
                actualList[i][property] = (property == 'quantity' && !value) ? 1 : value;
            }else{
                const prodTemp = {...prod, user_id: (Math.random() * 100).toString()};
                const nuevaEstructura = {...estructura_producto, user_id: (Math.random() * 100).toString()};
                if(prod.tipPro != ''){
                    if(actualList[i].tipPro !== ''){
                        actualList[i] = prodTemp;
                    }else{
                        actualList[i] = prodTemp;
                        actualList.push(nuevaEstructura);
                    }
                }
            }
            let newActivo = {...activo,['productos']:actualList}
            return newActivo;
        })
    }

    const handleDeleteProd = (prod, index) => {
        let actualProductos = activo.productos.slice();
        if(prod.tipPro != ''){
            let productosToUpdate = actualProductos.filter((p,i) => i != index);
            setActivo({...activo,['productos']:productosToUpdate});
        }
    }

    //Se utiliza para guardar un nuevo activo o cuando se parte de un Guardar como...
    const handleOnClick = async () => {    
        const { _id, __v, ...quitoID } = activo;
        let productosCompletados = activo.productos.filter(p => p.artCod != "");
        let logsFServCompletados = activo.logsFServ.filter(l => l.fecha != '' && l.evento.value != '');
        let logsUbicacionesCompletados = activo.logsUbicaciones.filter(l => l.fecha != '' && l.nivel1.value != '');
        let procedimientosCompletados = activo.procedimientos.filter(p => p.value != '');
        let lecturasCompletados = activo.lecturas.filter(l => l.fecha != '' && l.valor != ""); 
        let procsProgramadosCompletados = activo.procsProgramados.filter(p => p.codProc && p.codProc.value != '');
        let documentosCompletados = activo.documentos.filter(d => d.documento.label != '' && d.fecha != '');
        let fichaTecnicaCompleta = activo.fichaTecnica.filter(a => a.atributo.label != '' && a.valor != '');

        procedimientosCompletados = procedimientosCompletados.map(p => {
            let completadoInicial = p.lecturaCompletadoInicial;
            if(p.uniMed != 'DAYS'){
                completadoInicial = completadoInicial == null || completadoInicial == '' ? undefined : completadoInicial;
            }else completadoInicial = completadoInicial == '' ? '2000-01-01' : completadoInicial;
            return {...p, lecturaCompletadoInicial: completadoInicial};
        });

        logsUbicacionesCompletados = logsUbicacionesCompletados.map(l => ({...l, comUserID: (l.comUserID) ? l.comUserID : usuario._id, userName: (l.userName) ? l.userName : usuario.userName}));

        quitoID.procedimientos = procedimientosCompletados;
        quitoID.logsFServ = logsFServCompletados;
        quitoID.lecturas = lecturasCompletados;
        quitoID.procsProgramados = procsProgramadosCompletados;
        quitoID.documentos = documentosCompletados;
        quitoID.activoUserID = usuario?._id
        quitoID.userName = usuario.userName;
        quitoID.DEFAULTUNIMED = quitoID.DEFAULTUNIMED.value;
        quitoID.DEFAULTUNIMED2 = quitoID.DEFAULTUNIMED2?.value ?? '';
        quitoID.logsUbicaciones = logsUbicacionesCompletados;
        quitoID.fichaTecnica = fichaTecnicaCompleta;

        if(!quitoID.ajusteLecturas){
            console.log("No posee ajuste lecturas, se asignara 0");
            quitoID.ajusteLecturas = 0;
        }
        if(!quitoID.ajusteLecturas2){
            quitoID.ajusteLecturas2 = 0;
        }

        const primerError = validacion(quitoID,activo.activoType,productosCompletados);
        
        //Si no hay errores continua enviando el activo al backend.
        if ( primerError === "" ) { 
            
            quitoID.nivel1.id = quitoID.logsUbicaciones[0].nivel1.id;
            quitoID.activoNivel1ID = quitoID.logsUbicaciones[0].nivel1.id;
            quitoID.nivel1.value = quitoID.logsUbicaciones[0].nivel1.value;
            quitoID.codNivel1 = quitoID.logsUbicaciones[0].nivel1.value;
            
            quitoID.nivel2.id = quitoID.logsUbicaciones[0].nivel2.id;
            quitoID.activoNivel2ID = quitoID.logsUbicaciones[0].nivel2.id;
            quitoID.nivel2.value = quitoID.logsUbicaciones[0].nivel2.value;
            quitoID.codNivel2 = quitoID.logsUbicaciones[0].nivel2.value;
            
            quitoID.nivel3.id = quitoID.logsUbicaciones[0].nivel3.id;
            quitoID.activoNivel3ID = quitoID.logsUbicaciones[0].nivel3.id;
            quitoID.nivel3.value = quitoID.logsUbicaciones[0].nivel3.value;
            quitoID.nameNivel3 = quitoID.logsUbicaciones[0].nivel3.value;
            
            //Se agrego luego, se inserta If para evitar que activos ya creados se rompan.
            if(quitoID.nivel4){
                quitoID.nivel4.id = quitoID.logsUbicaciones[0].nivel4?.id ?? undefined;
                quitoID.activoNivel4ID = quitoID.logsUbicaciones[0].nivel4?.id ?? undefined;
                quitoID.nivel4.value = quitoID.logsUbicaciones[0].nivel4?.value ?? '';
                quitoID.codNivel4 = quitoID.logsUbicaciones[0].nivel4?.value ?? '';
            }
            
            if(quitoID.nivel5){
                quitoID.nivel5.id = quitoID.logsUbicaciones[0].nivel5?.id ?? undefined;
                quitoID.activoNivel5ID = quitoID.logsUbicaciones[0].nivel5?.id ?? undefined;
                quitoID.nivel5.value = quitoID.logsUbicaciones[0].nivel5?.value ?? '';
                quitoID.codNivel5 = quitoID.logsUbicaciones[0].nivel5?.value ?? '';
            }

            quitoID.solicitaLecturaODT = quitoID.solicitaLecturaODT?.value ?? '';

            const res = await agregarActivo(quitoID , productosCompletados, selectedFiles);   
            if(res.response != undefined){
                Swal.fire({
                    title:  "Error",
                    text: `${res.response.data.message}`,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
            }else{
                Swal.fire({
                    title: `Se guardo un nuevo activo`,
                    icon: 'success',
                    text: `Código: ${res.codActivo} \n Nombre: ${res.name} `,
                    showConfirmButton: true,
                    allowEnterKey: true
                });  
                actualizarActivoXproducto();    
                actualizaractivoList();
                handleOnClickCancelar();
            }
        }else{
            Swal.fire({
                title: primerError,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }   
    }; 
    
    //Se utiliza al momento de intentar guardar los datos editados de un activo.
    const handleOnClickEdit = async () => {
        setSaving(true);
        try {
        let procedimientosCompletados = activo.procedimientos.filter(p => p.value != '');
        procedimientosCompletados = procedimientosCompletados.map(p => {
            let completadoInicial = p.lecturaCompletadoInicial;
            if(p.uniMed != 'DAYS'){
                completadoInicial = completadoInicial == null || completadoInicial == '' ? null : completadoInicial;
            }else completadoInicial = completadoInicial == '' ? '2000-01-01' : completadoInicial;
            return {...p, lecturaCompletadoInicial: completadoInicial};
        });
        
        //Elimina la primer fila de cada subtabla, la cual siempre esta vacia.
        let productosCompletados = activo.productos.filter(p => p.artCod != "");
        let logsFServCompletados = activo.logsFServ.filter(l => l.fecha != '' && l.evento.value != '');
        let logsUbicacionesCompletados = activo.logsUbicaciones.filter(l => l.fecha != '' && l.nivel1.value != '');        
        let lecturasCompletadas = activo.lecturas.filter(l => l.fecha != '' && l.uniMed != '');
        let procProgamadosCompletados = activo.procsProgramados.filter(p => p.codProc.value != '')
        let documentosCompletados = activo.documentos.filter(d => d.documento.label != '' && d.fecha != '');
        logsUbicacionesCompletados = logsUbicacionesCompletados.map(l => ({...l, comUserID: (l.comUserID) ? l.comUserID : usuario._id, userName: (l.userName) ? l.userName : usuario.userName}));
        let fichaTecnicaCompleta = activo.fichaTecnica?.filter(a => a.atributo.label != '' && a.valor != '');

        //Setea las propiedades con los valores filtrados.
        let activoToUpload = {...activo, solicitaLecturaODT: activo.solicitaLecturaODT?.value ?? '', DEFAULTUNIMED: activo.DEFAULTUNIMED.value, DEFAULTUNIMED2: activo.DEFAULTUNIMED2?.value ?? '', procedimientos: procedimientosCompletados, logsFServ: logsFServCompletados, lecturas: lecturasCompletadas, procsProgramados: procProgamadosCompletados, documentos: documentosCompletados, logsUbicaciones: logsUbicacionesCompletados, fichaTecnica: fichaTecnicaCompleta};


        if(!activoToUpload.ajusteLecturas){
            console.log("No posee ajuste lecturas, se asignara 0");
            activoToUpload.ajusteLecturas = 0;
        }
        if(!activoToUpload.ajusteLecturas2){
            activoToUpload.ajusteLecturas2 = 0;
        }

        //Valida.
        const primerError = validacion (activoToUpload, {}, productosCompletados);

        if ( primerError === "" ) { //Si no hay ningun error prosigue
            
            //Si no se seteo un nivel 2 de ubicacion se establece que esto esta sin definir, caso contrario, se crean los valores de nivel 2 si es que no existen.
            if(!activoToUpload.logsUbicaciones[0].nivel2.value) activoToUpload.nivel2 = undefined;
            else if(!activoToUpload.nivel2){
                activoToUpload.nivel2 = {
                    codNivel2: activoToUpload.logsUbicaciones[0].nivel2.value,
                    descrp: activoToUpload.logsUbicaciones[0].nivel2.label,
                    id: activoToUpload.logsUbicaciones[0].nivel2.id,
                    name: activoToUpload.logsUbicaciones[0].nivel2.label
                }
            }

            //Si no se seteo un nivel 3 de ubicacion se establece que esto esta sin definir, caso contrario, se crean los valores de nivel 3 si es que no existen.
            if(!activoToUpload.logsUbicaciones[0].nivel3.value) activoToUpload.nivel3 = undefined;
            else if(!activoToUpload.nivel3){
                activoToUpload.nivel3 = {
                    codNivel3: activoToUpload.logsUbicaciones[0].nivel3.value,
                    descrp: activoToUpload.logsUbicaciones[0].nivel3.label,
                    id: activoToUpload.logsUbicaciones[0].nivel3.id,
                    label: activoToUpload.logsUbicaciones[0].nivel3.label,
                    nameNivel3: activoToUpload.logsUbicaciones[0].nivel3.label,
                    nivel3Nivel2ID: activoToUpload.logsUbicaciones[0].nivel2.id,
                    value: activoToUpload.logsUbicaciones[0].nivel3.value,
                }
            }

            //Si no se seteo un nivel 2 de ubicacion se establece que esto esta sin definir, caso contrario, se crean los valores de nivel 2 si es que no existen.
            if(!activoToUpload.logsUbicaciones[0].nivel4?.value) activoToUpload.nivel4 = undefined;
            else if(!activoToUpload.nivel4){
                activoToUpload.nivel4 = {
                    codNivel4: activoToUpload.logsUbicaciones[0].nivel4?.value ?? '',
                    descrp: activoToUpload.logsUbicaciones[0].nivel4?.label ?? '',
                    id: activoToUpload.logsUbicaciones[0].nivel4?.id ?? undefined,
                    name: activoToUpload.logsUbicaciones[0].nivel4?.label ?? ''
                }
            }

            //Si no se seteo un nivel 2 de ubicacion se establece que esto esta sin definir, caso contrario, se crean los valores de nivel 2 si es que no existen.
            if(!activoToUpload.logsUbicaciones[0].nivel5?.value) activoToUpload.nivel5 = undefined;
            else if(!activoToUpload.nivel5){
                activoToUpload.nivel5 = {
                    codNivel5: activoToUpload.logsUbicaciones[0].nivel5?.value ?? '',
                    descrp: activoToUpload.logsUbicaciones[0].nivel5?.label ?? '',
                    id: activoToUpload.logsUbicaciones[0].nivel5?.id ?? undefined,
                    name: activoToUpload.logsUbicaciones[0].nivel5?.label ?? ''
                }
            }
            
            //agregarActivo es la función que esta en el contex para hacer el POST.
            const res = await modificarActivo(activoToUpload, productosCompletados, selectedFiles, docFiles, fServFiles);

            if(res.response !== undefined) {
                Swal.fire({
                    title: `Error`,
                    icon: 'warning',
                    text: `${res.response.data.message}`,
                    showConfirmButton: true,
                    allowEnterKey: true
                });
            }else{
                Swal.fire({
                    title:  "Se modificó el activo",
                    icon: 'success',
                    text: `Código: ${res.codActivo}\n Nombre: ${res.name} `,
                    showConfirmButton: true,
                    allowEnterKey: true
                });
                actualizaractivoList();
                actualizarActivoXproducto();
                setModo('Vista');
                setActivoToHandle(res);
                handleOnClickCancelar();
            }
          }else{
              Swal.fire({
                  title:  primerError,
                  icon: 'warning',
                  showConfirmButton: true,
                  allowEnterKey: true
              });
          }
        } finally {
            setSaving(false);
        }
    }

    //Cancela la edicion de un Activo y setea el modo a Vista.
    const handleCancelNew = () => {
        setModo("Vista")  
    } 

    //cancelar en modo nuevo o el btn nuevo
    const handleOnClickCancelar = () => {
        setActivo(createEstructuraActivo());
        setOnClickInfo(false)
        setImage('')
        setSelectedFiles([]);
        setDocFiles([]);
        setFServFiles([]);
        setModo('Nuevo')
        setTimeout(()=> setReset((prevReset) => prevReset + 1), 1000);
    }
    
    //borra el activo
    const handleOnClickBorrar = () => {
        Swal.fire({
            title: `Estas seguro que deseas eliminar este Activo?`,
            icon: 'warning',
            text: `Se eliminara permanentemente!`,
            showConfirmButton: true,
            showCancelButton: true, // Habilita el botón de cancelar
            confirmButtonText: 'Eliminar',
            cancelButtonText:'No, cancelar',
            allowEnterKey: true

        }).then(async (result) => {
            if (result.isConfirmed) {
              // El usuario hizo clic en "Aceptar"
                const id = activo._id
                const resp = await eliminarActivo(id, activo, files);
                if(resp?.data?.success){
                    actualizaractivoList();
                    actualizarActivoXproducto();
                    handleOnClickCancelar();
                }
            } else if (result.isDismissed) {
             // El usuario hizo clic en "Cancelar" o en cualquier otro lugar fuera del diálogo
                  setModo("Vista")
                }
            });
    }

    const handleChangePriority = (e) => {
        setActivo({...activo,priority:e});
    }

    // esta funcion sirve p/ cuando volves a seleccionas una imagen borra la anterior
    const eliminaImg = () => {
        const nuevosDatos = selectedFiles.filter((dato) => dato.campo != "imagen");
        setSelectedFiles(nuevosDatos);
    }

    const closeModalDownloadQR = () => {
        setFormToShow('');
    }

    const handleDownloadQR = async() => {
        setFormToShow('QRDownloads');
    }

    //----------------------------------------------------------------//
    //useEffect encargado de modelar el activoToHandle seleccionado desde el Arbol de Activos.
    useEffect (() =>{
        if(Object.keys(activoToHandle).length > 1){
            let activoDesestructured =  {
                ...activoToHandle,

                solicitaLecturaODT: opcionesPedirLecturaActivo.find(o => o.value == activoToHandle.solicitaLecturaODT),

                criticidad: activoToHandle.criticidad ? activoToHandle.criticidad : '0',

                logsFServ: (activoToHandle.logsFServ == undefined || activoToHandle.logsFServ.length == 0) ? [{...createEstructuraLogsFServ(), user:{userName: usuario.userName, value: usuario.userName, label: usuario.userName, comUserID: usuario._id}}] : activoToHandle.logsFServ.map(l => l.rowKey ? l : {...l, rowKey: crypto.randomUUID()}),

                productos: (activoToHandle.productos != undefined && activoToHandle.productos.length > 0) ? activoToHandle.productos.slice() : [{...estructura_producto}],

                procedimientos: (activoToHandle.procedimientos != undefined && activoToHandle.procedimientos.length > 0) ? activoToHandle.procedimientos.slice() : [{...estructuraProcedimiento}],

                procsProgramados: (activoToHandle.procsProgramados != undefined && activoToHandle.procsProgramados.length > 0) ? activoToHandle.procsProgramados.slice() : [{...estructuraProcedimientoProgramado}],

                documentos: (activoToHandle.documentos != undefined && activoToHandle.documentos.length > 0) ? activoToHandle.documentos.slice() : [{...estructuraDocumento}],
                fichaTecnica: (activoToHandle.fichaTecnica != undefined && activoToHandle.fichaTecnica.length > 0) ? activoToHandle.fichaTecnica.slice() : [{...createEstructuraFichaTecnica()}],

                logsUbicaciones: (activoToHandle.logsUbicaciones == undefined || activoToHandle.logsUbicaciones.length == 0) ? [{...estructuraLogsUbicacion, user:{userName: usuario.userName, value: usuario.userName, label: usuario.userName, comUserID: usuario._id}}] : activoToHandle.logsUbicaciones.slice(),

                lecturas: (activoToHandle.lecturas == undefined || activoToHandle.lecturas == 0) ? [createEstructuraLectura()] : activoToHandle.lecturas.slice(),

                activoUserID : usuario?._id,

                userName : usuario.userName,

                // Campos de reserva con valores por defecto si no existen
                reservable: activoToHandle.reservable !== undefined ? activoToHandle.reservable : false,
                tipoReserva: activoToHandle.tipoReserva || null
            }

            let activoModelado = {...activoDesestructured};

            //Modela el tipo de activo para visualizarlo en SelectControl correctamente
            const idTipoActivoSeleccionado = activoModelado.tipoActivoID;
            const tipoActivoModelado = activoTypeList?.filter(name => name._id === idTipoActivoSeleccionado).map((dato) => ({
                value: dato.nameTypeActivo, label: dato.nameTypeActivo, id:dato._id, codTypeActivo:dato.codTypeActivo, nameTypeActivo:dato.nameTypeActivo, descrp: dato.descrp 
            }))
            activoModelado.activoType = tipoActivoModelado[0];
       
            //Modela nivel1 para visualizarla en SelectControl correctamente
            if(activoModelado.activoNivel1ID != undefined){
                const idNivel1Seleccionado = activoModelado.activoNivel1ID;
                const areaModelada = nivel1Lista?.filter(a => a._id === idNivel1Seleccionado).map( dato => ({ 
                    id: dato._id, name: dato.name, descrp:dato.descrp, codNivel1: dato.codNivel1
                }));
                activoModelado.nivel1 = areaModelada[0];
            }

            //Modela nivel2 para visualizarla en SelectControl correctamente
            if(activoModelado.activoNivel2ID != undefined){
                const idNivel2Seleccionado = activoModelado.activoNivel2ID;
                const nivel2Modelada = nivel2List?.filter(nivel2 => nivel2._id === idNivel2Seleccionado).map((nivel2) =>({
                    id: nivel2._id, value: nivel2.name, label: nivel2.name, name:nivel2.name, descrp: nivel2.descrp, codNivel2:nivel2.codNivel2 
                })) 
                activoModelado.nivel2 = nivel2Modelada[0];
            }
        
            //Modela nivel3 para visualizarlo en SelectControl correctamente
            if(activoModelado.activoNivel3ID != undefined){
                const idNivel3Seleccionado = activoModelado.activoNivel3ID;
                const nivel3Modelado = nivel3List?.filter(nivel3 => nivel3._id === idNivel3Seleccionado).map((name) =>({
                    value: name.nameNivel3, label: name.nameNivel3, nameNivel3:name.nameNivel3, codNivel3:name.codNivel3, descrp: name.descrp, id: name._id,nivel3Nivel2ID: name.nivel3Nivel2ID 
                }))
                activoModelado.nivel3 = nivel3Modelado[0];
            }

             //Modela nivel2 para visualizarla en SelectControl correctamente
             if(activoModelado.activoNivel4ID != undefined){
                const idNivel4Seleccionado = activoModelado.activoNivel4ID;
                const nivel4Modelada = nivel4List?.filter(nivel4 => nivel4._id === idNivel4Seleccionado).map((nivel4) =>({
                    id: nivel4._id, value: nivel4.name, label: nivel4.name, name:nivel4.name, descrp: nivel4.descrp, codNivel4:nivel4.codNivel4 
                })) 
                activoModelado.nivel4 = nivel4Modelada[0];
            }

             //Modela nivel2 para visualizarla en SelectControl correctamente
             if(activoModelado.activoNivel5ID != undefined){
                const idNivel5Seleccionado = activoModelado.activoNivel5ID;
                const nivel5Modelada = nivel5List?.filter(nivel5 => nivel5._id === idNivel5Seleccionado).map((nivel5) =>({
                    id: nivel5._id, value: nivel5.name, label: nivel5.name, name:nivel5.name, descrp: nivel5.descrp, codNivel5:nivel5.codNivel5 
                })) 
                activoModelado.nivel5 = nivel5Modelada[0];
            }

            //Se mapea el sistema y subsistema de los productos para visualizar los SelectControl correctamente
            let productosModelados = activoModelado.productos.slice();
            if(productosModelados[0].artCod != ''){
                productosModelados = productosModelados.map((p) => ({
                    ...p,sistema:{...p.sistema,label:p.sistema.name,label:p.sistema.name,value:p.sistema.name},subsistema:{...p.subsistema,label:p.subsistema.name,label:p.subsistema.name,value:p.subsistema.name}
                }));
            }
            
            let lecturasModelados;
            
            //if(activoToHandle.lecturas == undefined || activoToHandle.lecturas.length == 0) lecturasModelados = [{...estructuraLectura, fecha:newDate, user:{userName: usuario.userName, value: usuario.userName, label: usuario.userName, comUserID: usuario._id}}];
            //else lecturasModelados = activoToHandle.lecturas.slice();
            if(activoToHandle.lecturas != undefined || activoToHandle.lecturas.length > 0) lecturasModelados = activoToHandle.lecturas.slice();
            
            let procedimientosModelados = activoModelado.procedimientos.slice();
            let logsFServModelado = activoModelado.logsFServ.slice(); 
            
            let procsProgramadosModelados = activoModelado.procsProgramados.slice();
            let documentosModelados = activoModelado.documentos.slice();
            let fichaTecnicaModelada = activoModelado.fichaTecnica.slice();
            let logsUbicacionesModelado = activoModelado.logsUbicaciones.slice(); 

            for(const l of logsUbicacionesModelado){
                if(l.nivel1.value != ''){
                    let areaFiltered = nivel1Lista?.filter(a => a._id === l.nivel1.id)[0];
                    let nivel2Filtered = nivel2List?.filter(nivel2 => nivel2._id === l.nivel2?.id)[0];
                    let nivel3Filtered = nivel3List?.filter(nivel3 => nivel3._id === l.nivel3?.id)[0];
                    let nivel4Filtered = nivel4List?.filter(nivel4 => nivel4._id === l.nivel4?.id)[0];
                    let nivel5Filtered = nivel5List?.filter(nivel5 => nivel5._id === l.nivel5?.id)[0];

                    l.nivel1.label = (areaFiltered != undefined) ? areaFiltered.name : 'No presente en Xertux';
                    l.nivel1.name = (areaFiltered != undefined) ? areaFiltered.name : 'No presente en Xertux';
                    l.nivel1.descrp = (areaFiltered != undefined) ? areaFiltered.descrp : 'No presente en Xertux';
                    l.nivel1.value = (areaFiltered != undefined) ? areaFiltered.codNivel1 : '';
                    l.nivel1.codNivel1 = (areaFiltered != undefined) ? areaFiltered.codNivel1 : '';
                    l.nivel1.direccion = (areaFiltered != undefined) ? areaFiltered.direccion : '';
                    l.nivel1.lat = (areaFiltered != undefined) ? areaFiltered.lat : null;
                    l.nivel1.lng = (areaFiltered != undefined) ? areaFiltered.lng : null;
                                        
                    l.nivel2.label = !l.nivel2.id ? `Sin ${getValorActualFromDictionary("Nivel 2")}` : (nivel2Filtered != undefined) ? nivel2Filtered.name : 'No presente en Xertux';
                    l.nivel2.name = !l.nivel2.id ? `Sin ${getValorActualFromDictionary("Nivel 2")}` : (nivel2Filtered != undefined) ? nivel2Filtered.name : 'No presente en Xertux';
                    l.nivel2.descrp = !l.nivel2.id ? `Sin ${getValorActualFromDictionary("Nivel 2")}` : (nivel2Filtered != undefined) ? nivel2Filtered.descrp : 'No presente en Xertux';
                    l.nivel2.value = !l.nivel2.id ? `Sin ${getValorActualFromDictionary("Nivel 2")}` : (nivel2Filtered != undefined) ? nivel2Filtered.codNivel2 : '';
                    l.nivel2.codNivel2 = !l.nivel2.id ? `Sin ${getValorActualFromDictionary("Nivel 2")}` : (nivel2Filtered != undefined) ? nivel2Filtered.codNivel2 : '';
                    l.nivel2.direccion = !l.nivel2.id ? '' : (nivel2Filtered != undefined) ? nivel2Filtered.direccion : '';
                    l.nivel2.lat = !l.nivel2.id ? null : (nivel2Filtered != undefined) ? nivel2Filtered.lat : null;
                    l.nivel2.lng = !l.nivel2.id ? null : (nivel2Filtered != undefined) ? nivel2Filtered.lng : null;
                    
                    l.nivel3.label = !l.nivel3.id ? `Sin ${getValorActualFromDictionary("Nivel 3")}` : (nivel3Filtered != undefined) ? nivel3Filtered.nameNivel3 : 'No presente en Xertux';
                    l.nivel3.name = !l.nivel3.id ? `Sin ${getValorActualFromDictionary("Nivel 3")}` : (nivel3Filtered != undefined) ? nivel3Filtered.nameNivel3 : 'No presente en Xertux';
                    l.nivel3.descrp = !l.nivel3.id ? `Sin ${getValorActualFromDictionary("Nivel 3")}` : (nivel3Filtered != undefined) ? nivel3Filtered.descrp : 'No presente en Xertux';
                    l.nivel3.value = !l.nivel3.id ? `Sin ${getValorActualFromDictionary("Nivel 3")}` : (nivel3Filtered != undefined) ? nivel3Filtered.codNivel3 : '';
                    l.nivel3.codNivel3 = !l.nivel3.id ? `Sin ${getValorActualFromDictionary("Nivel 3")}` : (nivel3Filtered != undefined) ? nivel3Filtered.codNivel3 : '';
                    l.nivel3.direccion = !l.nivel3.id ? '' : (nivel3Filtered != undefined) ? nivel3Filtered.direccion : '';
                    l.nivel3.lat = !l.nivel3.id ? null : (nivel3Filtered != undefined) ? nivel3Filtered.lat : null;
                    l.nivel3.lng = !l.nivel3.id ? null : (nivel3Filtered != undefined) ? nivel3Filtered.lng : null; 
                    
                    if(l.nivel4){
                        l.nivel4.label = !l.nivel4?.id ? `Sin ${getValorActualFromDictionary("Nivel 4")}` : (nivel4Filtered != undefined) ? nivel4Filtered.name : 'No presente en Xertux';
                        l.nivel4.name = !l.nivel4?.id ? `Sin ${getValorActualFromDictionary("Nivel 4")}` : (nivel4Filtered != undefined) ? nivel4Filtered.name : 'No presente en Xertux';
                        l.nivel4.descrp = !l.nivel4?.id ? `Sin ${getValorActualFromDictionary("Nivel 4")}` : (nivel4Filtered != undefined) ? nivel4Filtered.descrp : 'No presente en Xertux';
                        l.nivel4.value = !l.nivel4?.id ? `Sin ${getValorActualFromDictionary("Nivel 4")}` : (nivel4Filtered != undefined) ? nivel4Filtered.codNivel4 : '';
                        l.nivel4.codNivel4 = !l.nivel4?.id ? `Sin ${getValorActualFromDictionary("Nivel 4")}` : (nivel4Filtered != undefined) ? nivel4Filtered.codNivel4 : '';
                        l.nivel4.direccion = !l.nivel4?.id ? '' : (nivel4Filtered != undefined) ? nivel4Filtered.direccion : '';
                        l.nivel4.lat = !l.nivel4?.id ? null : (nivel4Filtered != undefined) ? nivel4Filtered.lat : null;
                        l.nivel4.lng = !l.nivel4?.id ? null : (nivel4Filtered != undefined) ? nivel4Filtered.lng : null;
                    }
                    if(l.nivel5){
                        l.nivel5.label = !l.nivel5?.id ? `Sin ${getValorActualFromDictionary("Nivel 5")}` : (nivel5Filtered != undefined) ? nivel5Filtered.name : 'No presente en Xertux';
                        l.nivel5.name = !l.nivel5?.id ? `Sin ${getValorActualFromDictionary("Nivel 5")}` : (nivel5Filtered != undefined) ? nivel5Filtered.name : 'No presente en Xertux';
                        l.nivel5.descrp = !l.nivel5?.id ? `Sin ${getValorActualFromDictionary("Nivel 5")}` : (nivel5Filtered != undefined) ? nivel5Filtered.descrp : 'No presente en Xertux';
                        l.nivel5.value = !l.nivel5?.id ? `Sin ${getValorActualFromDictionary("Nivel 5")}` : (nivel5Filtered != undefined) ? nivel5Filtered.codNivel5 : '';
                        l.nivel5.codNivel5 = !l.nivel5?.id ? `Sin ${getValorActualFromDictionary("Nivel 5")}` : (nivel5Filtered != undefined) ? nivel5Filtered.codNivel5 : '';
                        l.nivel5.direccion = !l.nivel5?.id ? '' : (nivel5Filtered != undefined) ? nivel5Filtered.direccion : '';
                        l.nivel5.lat = !l.nivel5?.id ? null : (nivel5Filtered != undefined) ? nivel5Filtered.lat : null;
                        l.nivel5.lng = !l.nivel5?.id ? null : (nivel5Filtered != undefined) ? nivel5Filtered.lng : null;
                    }
                    
                    let userCreator = l.userName;
                    l.user = {userName: userCreator, value: userCreator, label: userCreator, comUserID: l.comUserID}
                }
            }

            //Si se edita o guarda como nuevo un Activo se le agrega un modelo vacio a cada Subtabla para poder trabajarlos normalmente.
            if(['Copia','Edicion'].includes(modo)){ 
                let newDate = getNewFormattedDate();

                (productosModelados.length == 0 || productosModelados[0].tipPro != '') && productosModelados.push(estructura_producto);
                
                (procedimientosModelados.length == 0 || procedimientosModelados[0].label != '') && procedimientosModelados.push({...createEstructuraProcedimiento()});
                
                (lecturasModelados.length == 0 || (lecturasModelados[0].fecha != '' && lecturasModelados[0].uniMed.value != '')) && lecturasModelados.push({...estructuraLectura, fecha:newDate, user:{userName: usuario.userName, value: usuario.userName, label: usuario.userName, comUserID: usuario._id}});
                
                (procsProgramadosModelados.length == 0 || procsProgramadosModelados[0].codProc.value != '') && procsProgramadosModelados.push({...estructuraProcedimientoProgramado});

                (documentosModelados.length == 0 || documentosModelados[0].documento.value != '') && documentosModelados.push({...estructuraDocumento});
                
                (fichaTecnicaModelada.length == 0 || fichaTecnicaModelada[0].atributo.value != '') && fichaTecnicaModelada.push({...createEstructuraFichaTecnica()});
                
                (logsFServModelado[0].fecha != ''  && logsFServModelado[0].evento.value != '') && logsFServModelado.push({...createEstructuraLogsFServ(), fecha:newDate, user:{userName: usuario.userName, value: usuario.userName, label: usuario.userName, comUserID: usuario._id}});
                
                (logsUbicacionesModelado[0].nivel1.value != '') && logsUbicacionesModelado.push({...estructuraLogsUbicacion, fecha:newDate, user:{userName: usuario.userName, value: usuario.userName, label: usuario.userName, comUserID: usuario._id}});
            }
            if(['Copia'].includes(modo)){
                procsProgramadosModelados = [{...estructuraProcedimientoProgramado}];
            }
            
            activoModelado.productos = productosModelados;
            activoModelado.procedimientos = procedimientosModelados;
            activoModelado.logsFServ = logsFServModelado.sort((a, b) => a.fecha > b.fecha ? -1 : 1);
            activoModelado.lecturas = lecturasModelados.sort((a, b) => a.fecha > b.fecha ? -1 : 1);
            activoModelado.procsProgramados = procsProgramadosModelados;
            activoModelado.documentos = documentosModelados;
            activoModelado.fichaTecnica = fichaTecnicaModelada;
            activoModelado.logsUbicaciones = logsUbicacionesModelado.sort((a, b) => a.fecha > b.fecha ? -1 : 1);
            //La propiedad criticidad no sirve para manejar el componente PrioritySelect por lo que se debe crear la propiedad original priority.
            activoModelado.priority = activoModelado.criticidad; 
            if(activoModelado.fecIng == undefined) activoModelado.fecIng = new Date().toISOString().substring(0,10);

            //deepCopy es necesario ya que si no, al editar un activo y clickear cancelar, las propiedades de las tablas hijas no volvian a su valor original, es decir el obtenido desde activoToHandle.
            let activoDeepCopy = JSON.parse(JSON.stringify(activoModelado));
            setActivo(activoDeepCopy);                   
        } 
    },[modo, activoToHandle])

    useEffect(() => {
         // Filtra las imágenes de files y obtén la URL de la primera imagen 'imagen'
        if(files != undefined){
            const imageUrl = (files.imagen==undefined) ? undefined : files.imagen[0].url;
            setImage(imageUrl || ''); // Si imageUrl es undefined, establece el estado como una cadena vacía

            const generalUrl = (files.general==undefined) ? undefined : files.general;
            setSelectedFiles(generalUrl ? generalUrl : []);

            if(files.docFiles && files.docFiles.length > 0){
                const existingDocFiles = files.docFiles.map(f => ({
                    codDocumento: f.codDocumento,
                    name: f.name,
                    existingName: f.name,
                    url: f.url
                }));
                setDocFiles(existingDocFiles);
            } else {
                setDocFiles([]);
            }

            if(files.fServFiles && files.fServFiles.length > 0){
                const existingFServFiles = files.fServFiles.map(f => ({
                    rowKey: f.rowKey,
                    name: f.name,
                    existingName: f.name,
                    url: f.url
                }));
                setFServFiles(existingFServFiles);
            } else {
                setFServFiles([]);
            }
        }
    }, [files]);

    useEffect(()=>{
        if(modo === 'Copia' || modo === 'Nuevo'){
            setImage('') 
        }
    },[modo])

    //useEffect que se ejecuta al cambiar cualquiera de la listas cuyos valores se usan como opciones al crear un activo.
    useEffect(() => {
        createOptions();
    }, [activoTypeList,nivel1Lista,nivel2List,nivel3List,nivel4List,nivel5List,activo.nivel1,activo.nivel2]);

    //useEffect que se ejecuta para inicializar los select y al primer log de cada subtabla asignarle el usuario logueado.
    useEffect(()=>{
        let newDate = getNewFormattedDate();
        
        setActivo((prevActivo) => {
            let activoToSet = {...prevActivo};
            activoToSet.logsUbicaciones[0].fecha = newDate;
            activoToSet.logsUbicaciones[0].user = {userName: usuario.userName, value: usuario.userName, label: usuario.userName, comUserID: usuario._id};
            activoToSet.logsFServ[0].fecha = newDate;
            activoToSet.logsFServ[0].user = {userName: usuario.userName, value: usuario.userName, label: usuario.userName, comUserID: usuario._id};
            activoToSet.lecturas[0] = createEstructuraLectura();
            activoToSet.lecturas[0].fecha = newDate;
            activoToSet.lecturas[0].user = {userName: usuario.userName, value: usuario.userName, label: usuario.userName, comUserID: usuario._id};            
            return activoToSet
        })
    },[reset]);

    if(activo != undefined) return (
        <div style={{ height:'115vh', width:'100%'}}>
            <div style={{ padding: '.5rem', backgroundColor: "white", height:'100%', display:'flex', justifyContent:'space-between', flexDirection: 'column' }}>
                <div className='thirdContainerFormActivo' style={{backgroundColor:PRINCIPAL, color:NAVBARS}}>
                    <h3>Registrar Activo</h3>                    
                </div>
                <div className='containerBtnsHandlePersistenceActivo'>
                    {
                        (modo === "Edicion" ||  modo === "Nuevo" || modo === "Copia") && ( 
                        <>
                            <button
                            style={{ backgroundColor: SECUNDARY_COLOR, margin: "0 .2rem", padding: ".5rem 2.2rem", opacity: saving ? 0.7 : 1 }}
                            className='button-action'
                            onClick={modo === "Edicion" ? handleOnClickEdit : handleOnClick }
                            disabled={saving}
                            >{saving ? "Guardando..." : (modo === "Edicion" ? "Guardar cambios" : "Guardar")}
                            </button> 
                            <button className='button-action' style={{ backgroundColor: "red", margin: "0 .2rem" }}
                            onClick={modo === "Nuevo" ? handleOnClickCancelar : handleCancelNew}>Cancelar</button>
                        </>
                        )
                    }
                    
                    {
                        modo === "Vista" && (
                            <>
                                <button className='button-action' style={{ backgroundColor: "green", margin: "0 .2rem", padding: ".5rem 2.2rem"  }}
                                onClick={()=>{handleOnClickCancelar();setModo("Nuevo");}}
                                >Nuevo</button>
                                <button 
                                style={{ backgroundColor: SECUNDARY_COLOR, margin: "0 .2rem", padding: ".5rem 2.2rem" }}
                                className='button-action' 
                                onClick={()=>(handleOnClickEditar(activo,'fromABMActivo'))}
                                >Editar
                                </button>
                                <button 
                                style={{ backgroundColor: "red", margin: "0 .2rem", padding: ".5rem 2.2rem"  }}
                                className='button-action' 
                                onClick={handleOnClickBorrar}
                                >Eliminar
                                </button>
                            </>    
                        )
                    }
                </div>
                <div style={{ display: "flex"}}>
                    <div style={{ flex: 2, display: "flex", flexDirection: "column"}}>
                        <div style={{flexGrow: 1}}>
                            {   
                                image ? 
                                    <img src={image} style={{width: "100%", height: "100%", maxHeight: "15rem", objectFit: 'contain'}} alt="Imagen seleccionada" />
                                :
                                    <div style={{ width: "100%", height: "100%",  borderRadius: ".5rem", borderStyle: "dashed", border: "2px dashed #cccc" , display: "flex", marginTop: "1rem", flexDirection: "column",justifyContent: "center", alignItems: "center"}}>
                                        <FontAwesomeIcon icon={faImage} color={"gray"} style={{ fontSize: "4rem" }} /> 
                                        <div style={{ color: "gray" }}>Agregar imagen del Activo</div>
                                    </div>
                            }
                        </div>
                        <input disabled={modo === "Vista"} type="file" id="fileInput" accept="image/*"
                            style={{ display: 'none' }} onChange={handleFileChange} />  
                        {
                            !image ? 

                            <label htmlFor="fileInput" className="custom-file-label">
                                Selecciona una Imagen
                            </label>  
                            :
                            <label htmlFor="fileInput" className="custom-file-label" onClick={eliminaImg} >
                                Cambia la Imagen
                            </label>  
                        }
                                
                    </div>
                    
                    <div style={{ flex: 3, display: "flex",  flexDirection: "column", padding: "0 0 0 1rem", margin: "0 .5rem", marginTop: "1rem", height: "100%" }}>
                        <div style={{ display: "flex"}}>
                            <input disabled={modo === "Vista" || modo === "Edicion"} className='input-form-mt' style={{ margin: "0 .2rem", fontSize:'1.5rem',fontWeight:500 }} type="text" placeholder='Ingrese CODIGO del Activo' value={activo.codActivo} name="codActivo" onChange={handleChange}/>

                             <input disabled={modo === "Vista"} className='input-form-mt' style={{ margin: "0 .2rem",fontSize:'1.5rem', fontWeight:500 }} type="text" placeholder='Ingrese NOMBRE del Activo' value={activo.name} name="name" onChange={handleChange}/>   
                        </div>

                        <div style={{ display: "flex",flexGrow: 1, borderWidth: 1,  flexDirection: "column" }}>
                            <div className='label-form-mt'>Descripcion (opcional)</div>
                            <textarea disabled={modo === "Vista"} className='input-form-mt' style={{ display: "flex", flexGrow: 1 }} placeholder='Describa el activo' value={activo.descrp} name="descrp" onChange={handleChange}/>
                        </div>
                    </div>
                </div>

                <div className='containerFlexFormActivo'>
                    <div style={{ border: "2px solid #cccc", padding: ".5rem", borderRadius: ".5rem", margin: "2rem 0px 1rem 0px", width:'50%' }}>
                        <div className='label-form-mt' >Campos ERP (opcional)</div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div style={{ flex: 1, marginRight: ".2rem" }}>
                                <div className='label-form-mt' >TipPro</div>
                                    <input disabled={modo === "Vista"} className='input-form-mt'  placeholder='Ingrese codigo tipPro' value={activo.tipPro} name="tipPro" onChange={handleChange}/>
                            </div >
                            <div style={{ flex: 1, marginLeft: ".2rem" }}>
                                <div className='label-form-mt' >ArtCod</div>
                                    <input disabled={modo === "Vista"} className='input-form-mt' placeholder='Ingrese codigo artCod' value={activo.artCod} name="artCod" onChange={handleChange}/>
                            </div>
                        </div>                    
                    </div>
                    <div className="divInputGroupFechaIngreso">
                        <label>Fecha de Ingreso:</label>
                        <input disabled={modo === "Vista"} type='date' value={activo.fecIng} name='fecIng' onChange={handleChange}/>
                    </div>  
                </div>                        


                <div className='priorityDiv'>
                    <div className='inputGroup'>
                        <label className='labelPriorityDiv'>Criticidad:</label>
                        <PrioritySelect document={activo} handleChange={handleChangePriority}/>
                    </div>
                    <div className='inputGroup'>
                        <label className='labelFServDiv'>Lecturas por defecto en:</label>
                        <Select
                            isDisabled={modo === "Vista"}
                            styles={{
                                input: (base) => ({
                                    ...base,
                                    width: "100%",
                                    padding: ".4rem",
                                    borderRadius: ".5rem",
                                    fontSize: "1rem",
                                    transition: "border-color .5s"
                                })
                            }}
                            placeholder="Elija unidad de medida..."
                            options={options.unidadesMedidasOpciones}
                            className='select'
                            value={activo.DEFAULTUNIMED}
                            onChange={(selectedOption) => handleChange({},'DEFAULTUNIMED',selectedOption)}
                            />
                    </div>
                    <div className='inputGroup'>
                        <label className='labelFServDiv'>Ajuste Lectura:</label>
                        <input style={{height:'45px'}} disabled={modo === "Vista"} value={activo.ajusteLecturas || 0} name="ajusteLecturas" className='inputAjusteLect' placeholder="Ingrese valor" type="number" onChange={(e) => handleChange(e)}/>

                    </div>
                                       
                    <div className='inputGroup'>
                        <label className='labelFServDiv'>Vida Útil:</label>
                        <input style={{height:'45px'}} value={activo.vidaUtil || 0} name="vidaUtil" className='inputAjusteLect' placeholder="Ingrese vida util estimada" type="number" onChange={(e) => handleChange(e)}/>
                    </div>
                    <div className='inputGroup'>
                        <label className='labelFServDiv'>Fuera de Servicio:</label>
                        <input checked={(activo.actStatus != undefined && activo.actStatus == 'FSERV') ? true : false} id="fServCheckbox" type='checkbox' name='fServ' readOnly/>
                    </div>
                </div>
                
                <div style={{display:'flex', gap: 24, justifyContent:'center', alignItems:'center', marginTop:16, marginBottom:16}}>
                    <div className='inputGroup'>
                        <label className='labelFServDiv'>Unidad Medida Secundaria:</label>
                        <Select
                            isDisabled={modo === "Vista" || !activo.DEFAULTUNIMED?.value}
                            isClearable
                            styles={{
                                input: (base) => ({
                                    ...base,
                                    width: "100%",
                                    padding: ".4rem",
                                    borderRadius: ".5rem",
                                    fontSize: "1rem",
                                    transition: "border-color .5s"
                                })
                            }}
                            placeholder="Elija unidad de medida..."
                            options={(options?.unidadesMedidasOpciones || []).filter(o => o.value !== activo.DEFAULTUNIMED?.value)}
                            className='select'
                            value={activo.DEFAULTUNIMED2?.value ? activo.DEFAULTUNIMED2 : null}
                            onChange={(selectedOption) => handleChange({},'DEFAULTUNIMED2', selectedOption ?? {label:'', value:''})}
                            />
                    </div>

                     <div className='inputGroup' style={{display:'flex', flexDirection:'column',height:'100%'}}>
                        <label className='labelFServDiv'>Ajuste Lectura 2:</label>
                        <input style={{flex:1}} disabled={modo === "Vista" || !activo.DEFAULTUNIMED?.value} value={activo.ajusteLecturas2 || 0} name="ajusteLecturas2" className='inputAjusteLect' placeholder="Ingrese valor" type="number" onChange={(e) => handleChange(e)}/>
                    </div>
                </div>


                <div style={{ padding: ".5rem", borderRadius: ".5rem", margin: "1rem 0px 0px 0px", display:'flex', flexDirection:'column', alignItems:'center' }}>
                    <div className='label-form-mt label-form-mt-section labelFormActivo labelSolicitaCargaLectODT' >Solicitar carga de lectura al finalizar Orden de Trabajo</div>
                    <div style={{ display: "flex", marginTop:'0.5rem', width:'40%' }}>
                        <SelectControl modo={modo} setModo={setModo} handleChengeSelect={handleChange} setData={setDataTypeList} optionsSelect={opcionesPedirLecturaActivo} valueSeleccionada={activo.solicitaLecturaODT} setShowAdd={setAddFormToShow} selectSelect={handleChange} 
                        placeholder={"Elija el Tipo Activo que corresponda..."} setNuevoEditado={setNuevoEditado} tipo={'solicitaLecturaODT'} propToChange={'solicitaLecturaODT'}
                        />
                    </div>
                </div>

                <div style={{ padding: ".5rem", borderRadius: ".5rem", margin: "1rem 0px" }}>
                    <div className='label-form-mt label-form-mt-section labelFormActivo' >Tipo Activo</div>
                    <div style={{ display: "flex" }}>
                        <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <div className='label-form-mt' style={{ marginRight: ".5rem" }}>Activo Fijo</div>
                            <input type="checkbox" disabled={modo === "Vista"} checked={activo.fijo} name='fijo'  onChange={(e)=>handleChange(e,'fijo')}/>
                        </div>
                        <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <div className='label-form-mt' style={{ marginRight: ".5rem" }}>Habilitado para Producción</div>
                            <input type="checkbox" disabled={modo === "Vista"} checked={activo.habilitadoProduccion} name='habilitadoProduccion' onChange={(e)=>handleChange(e,'habilitadoProduccion')}/>
                        </div>
                        <SelectControl modo={modo} setModo={setModo} handleChengeSelect={handleChange} setData={setDataTypeList} optionsSelect={options.opcionesTipoActivos} valueSeleccionada={activo.activoType} setShowAdd={setAddFormToShow} selectSelect={handleChange}
                        placeholder={"Elija el Tipo Activo que corresponda..."} setNuevoEditado={setNuevoEditado} tipo={'activoType'}
                        />
                    </div>
                </div>

                {/* Sección de Reservas */}
                <div style={{ padding: ".5rem", borderRadius: ".5rem", margin: "1rem 0px", border: "2px solid #e0e0e0" }}>
                    <div className='label-form-mt label-form-mt-section labelFormActivo' >Configuración de Reservas</div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "1rem", padding: "1rem" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className='label-form-mt' style={{ marginRight: ".5rem", flex: 1 }}>Reservable:</div>
                            <input
                                type="checkbox"
                                disabled={modo === "Vista"}
                                checked={activo.reservable || false}
                                name='reservable'
                                onChange={(e)=> setActivo({...activo, reservable: e.target.checked})}
                            />
                        </div>
                        {activo.reservable && (
                            <>
                                <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                                    <div className='label-form-mt'>Tipo de Reserva:</div>
                                    <select
                                        disabled={modo === "Vista"}
                                        className='input-form-mt'
                                        value={activo.tipoReserva || ''}
                                        onChange={(e) => setActivo({...activo, tipoReserva: e.target.value || null})}
                                    >
                                        <option value="">Seleccione tipo...</option>
                                        <option value="CANCHA_TENIS">Cancha de Tenis</option>
                                        <option value="CANCHA_PADEL">Cancha de Pádel</option>
                                        <option value="SALA_REUNION">Sala de Reunión</option>
                                    </select>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <div style={{ display: "flex" }}>
                    <div style={{ flex: 2, padding: ".5rem", borderRadius: ".5rem", margin: "1rem 0px" }}>
                        <div className='label-form-mt label-form-mt-section' >Ubicacion</div>
                        <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
                            <div style={{ flex: 1, margin: "1rem 0.2rem 1rem" }}>
                                <div className='label-form-mt' ><DictionaryText text={"Nivel 1"}/></div>
                                <SelectControl modo={'Vista'/*modo*/} setModo={setModo} optionsSelect={options.opcionesNivel1s} handleChengeSelect={handleChange} 
                                valueSeleccionada={activo.nivel1} setShowAdd={setAddFormToShow} selectSelect={handleChange} setNuevoEditado={setNuevoEditado} tipo={'nivel1'}
                                />
                            </div >
                            <div style={{ flex: 1, margin: "1rem 0.2rem 1rem" }}>
                                <div className='label-form-mt' ><DictionaryText text={"Nivel 2"}/></div>
                                <SelectControl modo={'Vista'} setModo={setModo} optionsSelect={options.opcionesNivel2s} handleChengeSelect={handleChange} 
                                    valueSeleccionada={activo.nivel2} setShowAdd={setAddFormToShow} selectSelect={handleChange} setNuevoEditado={setNuevoEditado} tipo={'nivel2'}
                                />
                            </div>
                            <div style={{ flex: 1, margin: "1rem 0.2rem 1rem" }}>
                                <div className='label-form-mt' ><DictionaryText text={"Nivel 3"}/></div>
                                <SelectControl modo={'Vista'} setModo={setModo} optionsSelect={options.opcionesNivel3s} handleChengeSelect={handleChange} valueSeleccionada={activo.nivel3} setShowAdd={setAddFormToShow} selectSelect={handleChange} setNuevoEditado={setNuevoEditado} tipo={'nivel3'}
                                />
                            </div>
                            <div style={{ flex: 1, margin: "1rem 0.2rem 1rem" }}>
                                <div className='label-form-mt' ><DictionaryText text={"Nivel 4"}/></div>
                                <SelectControl modo={'Vista'} setModo={setModo} optionsSelect={options.opcionesNivel4s} handleChengeSelect={handleChange} valueSeleccionada={activo.nivel4} setShowAdd={setAddFormToShow} selectSelect={handleChange} setNuevoEditado={setNuevoEditado} tipo={'nivel4'}
                                />
                            </div>
                            <div style={{ flex: 1, margin: "1rem 0.2rem 1rem" }}>
                                <div className='label-form-mt' ><DictionaryText text={"Nivel 5"}/></div>
                                <SelectControl modo={'Vista'} setModo={setModo} optionsSelect={options.opcionesNivel5s} handleChengeSelect={handleChange} valueSeleccionada={activo.nivel5} setShowAdd={setAddFormToShow} selectSelect={handleChange} setNuevoEditado={setNuevoEditado} tipo={'nivel5'}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", padding: ".5rem" }}>
                        <div style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", border: "2px solid gray", padding: ".5rem 3rem", borderRadius: ".5rem" }}>
                            <div className='label-form-mt' >Código QR</div>
                            <div ref={refQr}>
                                <QRCode value={(activo.codActivo != '') ? `${activo.codActivo}` : ``}/>
                            </div>
                            <button className='downloadQRBtn' onClick={handleDownloadQR}>Descargar PDF QR</button>
                        </div>
                    </div>
                </div>
                
                <BtnArchivos modo={modo} files={files} selectedFiles={selectedFiles} setSelectedFiles={setSelectedFiles} componentePadre='FormActivo'/>

                <div className='tablasHijasDiv'>
                    <div className="opcionesHijasDiv">
                        <button className={(tablaSeleccionada === 'fichaTecnica') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('fichaTecnica')}>Ficha Técnica</button>
                        <button className={(tablaSeleccionada === 'componentes') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('componentes')}>Componentes</button>
                        <button className={(tablaSeleccionada === 'docVencimiento') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('docVencimiento')}>Documentos</button>
                        <button className={(tablaSeleccionada === 'procedimientosXactivo') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('procedimientosXactivo')}>Procedimientos Asociados</button>
                        <button className={(tablaSeleccionada === 'fueraServicio') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('fueraServicio')}>Disponibilidad</button>
                        <button className={(tablaSeleccionada === 'ubicaciones') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('ubicaciones')}>Ubicaciones</button>
                        {activo.reservable && activo.tipoReserva === 'CANCHA_TENIS' && (
                            <button className={(tablaSeleccionada === 'bloqueos') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('bloqueos')}>Bloqueos</button>
                        )}
                        <button className={(tablaSeleccionada === 'lecturas') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('lecturas')}>Lecturas</button>
                        <button className={(tablaSeleccionada === 'procedimientosProgramados') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('procedimientosProgramados')}>Procedimientos Programados</button>
                    </div>
                    
                    <FichaTecnicaSubtabla handleChangeActivo={handleChange} selectSelect={handleChange} modo={modo} fichaTecnica={activo.fichaTecnica} tablaSeleccionada={tablaSeleccionada} usuario={usuario}/>

                    <ProductosSubtabla productos={activo.productos} handleChangeProductos={handleChangeProductos} handleDeleteProd={handleDeleteProd} componentePadre='Activo' modo={modo} tablaSeleccionada={tablaSeleccionada} usuario={usuario}/>

                    <DocumentosSubtabla handleChangeActivo={handleChange} selectSelect={handleChange} modo={modo} documentos={activo.documentos} tablaSeleccionada={tablaSeleccionada} usuario={usuario} docFiles={docFiles} onDocFileChange={handleDocFileChange}/>

                    <ProcedimientosXactivoSubtabla activoUniMed={activo.DEFAULTUNIMED} activoType={activo.activoType} procedimientosXactivo={activo.procedimientos} handleChangeActivo={handleChange} selectSelect={handleChange} modo={modo} tablaSeleccionada={tablaSeleccionada} usuario={usuario}/>

                    <FueraServicioSubtabla logsActivo={activo.logsFServ} fServChecked={activo.fServ} handleChenge={handleChange} modo={modo} logsOriginales={(Object.keys(activoToHandle).length > 0 && modo != 'Nuevo') && activoToHandle.logsFServ} fServOriginal={(Object.keys(activoToHandle).length > 0 && modo != 'Nuevo') && activoToHandle.fServ} tablaSeleccionada={tablaSeleccionada} usuario={usuario} opcionesUsers={options.opcionesUsers} fServFiles={fServFiles} onFServFileChange={handleFServFileChange}/>

                    <LecturasSubtabla lecturas={activo.lecturas} handleChangeActivo={handleChange} modo={modo} tablaSeleccionada={tablaSeleccionada} componentePadre='Activo' opcionesUsers={options.opcionesUsers} usuario={usuario}/>

                    <ProcedimientosProgramadosSubtabla procsProgramados={activo.procsProgramados} handleChangeActivo={handleChange} modo={modo} tablaSeleccionada={tablaSeleccionada} componentePadre='Activo' usuario={usuario}/>

                    <UbicacionesSubtabla logsUbicaciones={activo.logsUbicaciones} usuario={usuario} handleChenge={handleChange} modo={modo} tablaSeleccionada={tablaSeleccionada} nivel5List={nivel5List} nivel4List={nivel4List} nivel3List={nivel3List} nivel2List={nivel2List} nivel1Lista={nivel1Lista} opcionesUsers={options.opcionesUsers}/>

                    {activo.reservable && activo.tipoReserva === 'CANCHA_TENIS' && (
                        <BloqueosSubtabla activoID={activo._id} tablaSeleccionada={tablaSeleccionada} />
                    )}
                </div>
            </div>

            {(addFormToShow == 'activoType') &&
                <div className='modalUser'>
                    <FormActivoType
                        setData={setDataTypeList}
                        data={datoGuardar !== '' ? dataTypeList : {...datoGuardar, value: datoGuardar?.nameTypeActivo, label: datoGuardar?.nameTypeActivo, id:datoGuardar?._id}}
                        formDato={activo}
                        datoGuardar={datoGuardar}
                        nuevoEditado={nuevoEditado}
                        minimizar={() =>setAddFormToShow('')}
                                
                    />
                </div>
            }
            {formToShow != '' && <ModalForm activoSelected={{label: activo.name, value: activo.codActivo}} formToShow={formToShow} minimizar={closeModalDownloadQR}/>}
        </div>
    );
}

export default FormActivo;